import React from 'react';
import {
  ComposedChart,
  Line,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
} from 'recharts';


const BarChartSample = ({data, width}) => {
  return (
    <div className="grid-item">
      <h4 className="px-5 py-2 mb-4 text-light-gray text-center bg-light-blue">BarChart Example</h4>
      <ComposedChart
        width={width}
        height={width * 0.6}
        data={data}
        margin={{
          top: 20,
          right: 80,
          bottom: 20,
          left: 20,
        }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="name" label={{ position: 'insideBottomRight', offset: 0 }} scale="band" />
        <YAxis label={{ angle: -90, position: 'insideLeft' }} />
        <Tooltip />
        <Legend />
        <Bar dataKey="pv" barSize={60} fill="#413ea0" background={{ fill: '#eee' }} />
        <Line type="monotone" dataKey="uv" stroke="#ff7300" />
      </ComposedChart>
    </div>
  );
};

export default BarChartSample;
